var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"padding-top":"100px"}},[_c('System_Manager',{attrs:{"namespace":_vm.namespace}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }